module.exports = __webpack_public_path__ + "static/media/world_icon.fw.7837255a.png";